// src/config.js
const config = {
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5009',
};

export default config;
